import React from "react";
import {
  Animator,
  ScrollContainer,
  ScrollPage,
  batch,
  Fade,
  FadeIn,
  FadeOut,
  Move,
  MoveIn,
  MoveOut,
  Sticky,
  StickyIn,
  StickyOut,
  Zoom,
  ZoomIn,
  ZoomOut,
} from "react-scroll-motion";
import Me from "../Components/Me";
import Typed from "react-typed";
import { BsArrowDown } from "react-icons/bs";
import { AiOutlineHtml5 } from "react-icons/ai";
import { TbBrandCss3 } from "react-icons/tb";
import { DiJavascript1, DiReact } from "react-icons/di";
import { FaBootstrap } from "react-icons/fa";
import { SiTailwindcss, SiFirebase } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa";
import Navbar from "../SharedPage/Navbar";

const AboutPage = () => {
  const ZoomInScrollOut = batch(StickyIn(), FadeIn(), ZoomIn());
  const FadeUp = batch(Fade(), Move(), Sticky());
  return (
    <div>
      <Navbar />
      <div id="about" className="lg:w-11/12 mx-auto">
        <div>
          {/* ---------- animation------- */}
          <ScrollContainer>
            <ScrollPage>
              <Animator animation={batch(Fade(), Sticky(), MoveOut(0, -200))}>
                <span className="flex w-full items-center">
                  <Typed
                    className="lg:text-5xl text-xl font-thin lg:pr-5 tracking-wider h_tag text-secondary"
                    strings={[`Hurreee! You reached me.`]}
                    typeSpeed={100}
                    loopCount
                  />
                  <BsArrowDown data-aos="fade-left" data-aos-delay="3000" />
                  <br />
                </span>
              </Animator>
            </ScrollPage>
            <ScrollPage>
              <Animator animation={ZoomInScrollOut}>
                <span className="text-base-100 lg:text-5xl text-2xl opacity-40">
                  Good to see you
                </span>
              </Animator>
            </ScrollPage>
            <ScrollPage>
              <Animator animation={FadeUp}>
                <span style={{ fontSize: "40px" }}>
                  <div className="h-[700px] w-[100vw]">
                    <h1 className="text-center mb-20">SKILLS</h1>
                    <div className="grid grid-cols-1 md:grid-cols-2 w-10/12 mx-auto lg:grid-cols-4 ">
                      {/* -------- icon ------ */}

                      <span className=" gap-5 p-3 bg-secondary text-center flex justify-center items-center w-72 rounded-full my-4 h-40">
                        <AiOutlineHtml5 className="text-8xl" />
                      </span>

                      <span className=" gap-5 p-3 bg-secondary text-center flex justify-center items-center w-72 rounded-full my-4 h-40">
                        <TbBrandCss3 className="text-8xl" />
                      </span>

                      <span className=" gap-5 p-3 bg-secondary text-center flex justify-center items-center w-72 rounded-full my-4 h-40">
                        <DiJavascript1 className="text-8xl" />
                      </span>

                      <span className=" gap-5 p-3 bg-secondary text-center flex justify-center items-center w-72 rounded-full my-4 h-40">
                        <FaBootstrap className="text-8xl" />
                      </span>

                      <span className=" gap-5 p-3 bg-secondary text-center flex justify-center items-center w-72 rounded-full my-4 h-40">
                        <SiTailwindcss className="text-8xl" />
                      </span>
                      <span className=" gap-5 p-3 bg-secondary text-center flex justify-center items-center w-72 rounded-full my-4 h-40">
                        <DiReact className="text-8xl" />
                      </span>

                      <span className=" gap-5 p-3 bg-secondary text-center flex justify-center items-center w-72 rounded-full my-4 h-40">
                        <SiFirebase className="text-8xl" />
                      </span>

                      <span className=" gap-5 p-3 bg-secondary text-center flex justify-center items-center w-72 rounded-full my-4 h-40">
                        <FaNodeJs className="text-8xl" />
                      </span>
                    </div>
                  </div>
                </span>
              </Animator>
            </ScrollPage>
            <ScrollPage>
              <div
                onc
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <div className="w-10/12 mx-auto text-center lg:text-3xl text-lg">
                  <span>
                    <Animator animation={MoveIn(-1000, 0)}>
                      <pre>Front End web developer</pre>
                    </Animator>
                    <pre> React.js Developer</pre>
                    <Animator animation={MoveOut(1000, 0)}>
                      Love to work in team 💛
                      <pre></pre>
                    </Animator>
                    <Animator animation={MoveOut(-1000, 0)}>
                      <pre> Interested in Ui design</pre>
                    </Animator>
                  </span>
                </div>
              </div>
            </ScrollPage>
            <ScrollPage>
              <Animator animation={batch(Fade())}>
                <span>
                  <Me />
                </span>
              </Animator>
            </ScrollPage>
          </ScrollContainer>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
